<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <b-container v-else>

        <router-link class="admin-link" to="/Admin/PhotoCategories">&larr; Перейти к списку категорий фото</router-link>

        <div class="admin-title">{{header}}</div>
        <hr class="my-4">

        <b-row class="m-0">

            <b-col cols="9" class="p-0">
                <label for="namePhoto">Наименование</label>
                <b-form-input id="namePhoto" v-model="entity.Name"/>
            </b-col>

            <b-col>                
                <label for="statusTodo">Статус</label>
                <yes-no-input v-model="entity.IsVisible"
                              text-yes='Активный'
                              text-no='Неактивный'/>                
            </b-col>

        </b-row>

        <hr class="my-4">

		<b-row class="m-0">

            <b-col cols="2" class="p-0 mr-10">
			    <b-button block 
                          id="admin-btn-save"
                          class="admin-button"    
                          @click="savePhotoCategory">
                    Сохранить
                </b-button>
            </b-col>

            <b-col cols="2" class="p-0">
			    <b-button block v-if="id"
                          id="admin-btn-cancel"
                          class="admin-button" 
                          @click="deletePhotoCategoryDialog">
                    Удалить
                </b-button>
            </b-col>

		</b-row>

    </b-container>

</template>
<script>
import AllRoutes from '@/routes/all.routes'
import Consts from '@/store/models/consts/adminConsts'

import apiService from '@/services/api.service'
import dialogService from '@/services/dialog.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'

import YesNoInput from '@/components/shared/YesNoInput'

import PhotoCategoryEditModel from '@/store/models/admin/photoCategories/PhotoCategoryEdit'


export default {
    data: function() {
        let load = new Loading();
        
        let id = Object.keys(this.$route.query).length 
                    ? this.$route.query.id 
                    : null;
        let entity;

        if(id)
            this.getPhotoCategory(load, id);
        else 
            entity = new PhotoCategoryEditModel();

        return {
            load: load,
            id: id,

            entity: entity
        }
    },
    computed: {
        header: function() {
            return this.id ? 'Редактирование категории фотографий' : 'Добавление категории фотографий';
        }
    },
    methods: {
        getPhotoCategory: function(load, id) {
            load.Calculate(true);

            apiService.Admin.PhotoCategories.Get(id)
                .then(response => {
                    this.entity = new PhotoCategoryEditModel().mapFromDto(response.data);
                    load.Calculate(false);
                })
                .catch(error => load.Calculate(false));
        },

        savePhotoCategory: function() {
            if(!this.entity.isValid()) {
                dialogService.showAlert( 'Предупеждение', 'Заполните поле Наименование');
                return;
            }

            this.load.Calculate(true);
            let photoCategory = this.entity.mapToDto();

            apiService.Admin.PhotoCategories.PostUpdate(photoCategory)
                .then(response => {
                    this.$router.push(AllRoutes.Admin.PhotoCategories.Index);
                })
                .catch(error => this.load.Calculate(false));
        },

        deletePhotoCategoryDialog: function() {
            dialogService.showConfirm('Подтверждение удаления', 'Вы действительно хотите удалить данную категорию фото?')
                .then(ok => this.deletePhotoCategory())
                .catch(cancel => {});
        },
        deletePhotoCategory: function() {
            this.load.Calculate(true);

            apiService.Admin.PhotoCategories.PostDelete(this.id)
                .then(response => {
                    this.$router.push(AllRoutes.Admin.PhotoCategories.Index);
                })
                .catch(error => this.load.Calculate(false));
        }

    },
    components: {
        Spinner,
        YesNoInput
    }
}
</script>